import { ChangeDetectorRef, Component, ElementRef, Input, Inject, OnDestroy, OnInit, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { NoteDataModel } from '../../../../models/notes/note-data.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { TdoNoteFilterModel } from '../models/tdo-note-filter.model';
import { NoteCategoryDataModel } from '../../../../models/notes/note-category-data.model';
import { NoteTypeDataModel } from '../../../../models/notes/note-type-data.model';
import { Subscription } from 'rxjs';
import { NotesService } from '../../../../services/notes.service';
import { MessagingService } from '../../../../services/messaging.service';
import { StaticDataService } from '../../../../services/static-data.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UiService } from '../../../../services/ui.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Globals } from '../../../../globals';
import { TdoNoteQueryModel } from '../models/tdo-note-query.model';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../models/tdo-note-save-model';
import { TdoNotesMultiselectMenuComponent } from '../tdo-notes-multiselect-menu/tdo-notes-multiselect-menu.component';
import { NoteGroupDescriptionModel } from '../../../../models/notes/note-group-description.model';
import { Constants } from '../../../../constants';
import { TdoNoteBuilderComponent } from '../../tdo-note-builder/tdo-note-builder.component';
import { TdoMacroNotesComponent } from '../../tdo-macro-notes/tdo-macro-notes.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LandingPageService } from '../../../../services/landing-page.service';
import { PatientCaseViewDataModel } from '../../../../models/patient/patient-case-view-data.model';
import { MatSelectChange } from '@angular/material/select';
import { DialogService } from 'src/app/services/dialog.service';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';


@Component({
  standalone: false,
  selector: 'app-tdo-notes-expanded',
  templateUrl: './tdo-notes-expanded.component.html',
  styleUrls: ['./tdo-notes-expanded.component.scss']
})
export class TdoNotesExpandedComponent implements OnInit, OnDestroy {
  @ViewChild('categoryDropdown') categoryDropdown: TdoNotesMultiselectMenuComponent;
  @ViewChild('typeDropdown') typeDropdown: TdoNotesMultiselectMenuComponent;

  @Input() listenToNoteQueryEvents: boolean = true;

  @Input() PatientID: string;
  @Input() CaseID: string;
  @Input() PatientName: string;
  @Input() NoteGroupId: string;
  @Input() ParentObjectName: string;
  @Input() ObjectId: string;

  @Input() categoryFilters: any[] = [];
  @Input() filteredMode: boolean = false;
  @Input() showAllFilter: any = { displayValue: 'Show all', selected: true };
  @Input() isDockedLeft = false;

  isMinimized = false;

  isShowAllCases: boolean = false;
  messagingSubscription: any;
  hideFilterButton: boolean = false;
  isLoading: boolean = true;
  deleteMode: boolean = false;
  hideFilters: boolean = true;
  notes: NoteDataModel[] = [];
  alertNotes: NoteDataModel[] = [];
  filteredNotes: NoteDataModel[] = [];

  objectsRelatedToPatient: NoteGroupDescriptionModel[] = [];
  selectedRelatedObjects: NoteGroupDescriptionModel[] = [];
  selectedTypes: string[];
  isShowSettings;

  storedUser;

  notesCategories: EnumValidValueItemModel[] = [];
  notesTypes: EnumValidValueItemModel[] = [];

  // Filter
  //////////////////////////////////////////////////////////////////////////////
  storedNoteFilterSettings: TdoNoteFilterModel;
  private allCategoryModel: NoteCategoryDataModel;
  private allTypeModel: NoteTypeDataModel;

  private isInitialized: boolean;
  private timeoutInstanceId: string;
  private subscriptions: Subscription[] = [];
  cases: PatientCaseViewDataModel[] = [];
  selectedCase: PatientCaseViewDataModel;

  allCase: PatientCaseViewDataModel = new PatientCaseViewDataModel();

  currentCaseId: string;
  patientId: string;
  patientCaseId: string;

  @ViewChildren('noteArea') noteArea!: QueryList<ElementRef<HTMLTextAreaElement>>;

  constructor(
    private notesService: NotesService,
    private messagingService: MessagingService,
    private el: ElementRef,
    private staticDataService: StaticDataService,
    private dialog: MatDialog,
    public uiService: UiService,
    private router: Router,
    public globals: Globals,
    private landingPageService: LandingPageService,
    private dialogService: DialogService,
    private activeRoute: ActivatedRoute,
    private dialogRef: MatDialogRef<TdoNotesExpandedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoteDataModel,
    private cdr: ChangeDetectorRef
  ) {

    this.allCase.Description = 'All cases for patient';
    this.allCase.PatientCaseId = '*';
    this.allCategoryModel = new NoteCategoryDataModel();
    const categoryAllEnum = new EnumValidValueItemModel();
    categoryAllEnum.ValidValueItemId = 'storedCategoryAll';
    categoryAllEnum.ItemDisplayValue = 'Show All Categories';
    this.allCategoryModel.enumNoteCategory = categoryAllEnum;
    this.allCategoryModel.enumNoteCategoryID = categoryAllEnum.ValidValueItemId;

    this.allTypeModel = new NoteTypeDataModel();
    const typeAllEnum = new EnumValidValueItemModel();
    typeAllEnum.ValidValueItemId = 'storedTypeAll';
    typeAllEnum.ItemDisplayValue = 'Show All Types';
    this.allTypeModel.enumNoteType = typeAllEnum;
    this.allTypeModel.enumNoteTypeID = typeAllEnum.ValidValueItemId;
    this.storedUser = JSON.parse(localStorage.getItem('storedUser'));

    const storedFilterSettings = localStorage.getItem('noteStandaloneFilterSettings');
    if (storedFilterSettings) {
      this.storedNoteFilterSettings = JSON.parse(storedFilterSettings) as TdoNoteFilterModel;
    } else {
      this.storedNoteFilterSettings = new TdoNoteFilterModel();
      this.storedNoteFilterSettings.notesCategories.push(this.allCategoryModel);
      this.storedNoteFilterSettings.notesTypes.push(this.allTypeModel);
      this.storedNoteFilterSettings.isFullView = false;
      this.storedNoteFilterSettings.isCondensedView = true;
      this.storedNoteFilterSettings.isShowModifiedOn = false;
      this.storedNoteFilterSettings.isShowModifiedBy = false;
    }

    const sub = this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart) {
        this.handleRouteChange(data);
      }
    });

    this.subscriptions.push(sub);

    this.patientId = this.globals.currentPatientId;
    this.patientCaseId = this.globals.currentPatientCaseId;
    this.activeRoute.queryParams.subscribe((res) => {
      if (res && res.patientId) {
        this.patientId = res.patientId;
      }

      if (res && res.patientCaseId) {
        this.patientCaseId = res.patientCaseId;
      }
    });
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  onChangeNotesDock(dockSide: string) {
    if (dockSide === 'left') {
      this.uiService.isNotesOnLeft = true;
    } else {
      this.uiService.isNotesOnLeft = false;
    }
  }

  saveFilterSettings() {
    localStorage.setItem('noteStandaloneFilterSettings', JSON.stringify(this.storedNoteFilterSettings));
  }

  ngOnInit() {
    this.currentCaseId = this.patientCaseId;
    this.landingPageService.getPatientsCases4Landing(this.patientId).subscribe((data) => {
      this.cases = data;
      this.cases.unshift(this.allCase);
    });

    // Timeout added so that the @HostListener event responsible for closing when clicking outside
    // does not fire from the icon click itself.
    setTimeout(() => {
      this.isInitialized = true;
    }, 0.1);

    

    if (this.staticDataService.validValueItems && this.staticDataService.validValueItems.length > 0) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }
  setupEnums() {
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    model.objectId = this.currentCaseId;
    this.notesCategories = this.staticDataService.getValidValueItemsByValidValueName('enumNoteCategory');
    this.notesTypes = this.staticDataService.getValidValueItemsByValidValueName('enumNoteType');
    this.notesCategories.sort((a, b) => a.ItemDisplayValue.localeCompare(b.ItemDisplayValue));
    this.notesTypes.sort((a, b) => a.ItemDisplayValue.localeCompare(b.ItemDisplayValue));
    this.getNotes(model);
    this.getAlertNotes();
  }

  onOkClick() {
    this.dialogRef.close(this.data);
  }

  sortNotes() {
    this.notes = this.notes.sort((a, b) => {
      const d1 = new Date(a.xauditCreatedOn);
      const d2 = new Date(b.xauditCreatedOn);
      if (d1 > d2) {
        return -1;
      } else if (d2 > d1) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  filterNotes() {
    if (this.storedNoteFilterSettings.notesCategories.length === 1 && this.storedNoteFilterSettings.notesTypes.length === 1
      && this.storedNoteFilterSettings.notesCategories[0].enumNoteCategoryID === this.allCategoryModel.enumNoteCategoryID && this.storedNoteFilterSettings.notesTypes[0].enumNoteTypeID === this.allTypeModel.enumNoteTypeID) {
      // Category and type filters set to all
      this.filteredNotes = this.notes;
    } else {
      this.filteredNotes = [];
      if (this.storedNoteFilterSettings.notesCategories[0].enumNoteCategoryID === this.allCategoryModel.enumNoteCategoryID) {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteTypes.find(e => this.storedNoteFilterSettings.notesTypes.map(h => h.enumNoteTypeID).includes(e.enumNoteTypeID));
          if (d) {
            return p;
          }
        });
      } else if (this.storedNoteFilterSettings.notesTypes[0].enumNoteTypeID === this.allTypeModel.enumNoteTypeID) {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteCategories.find(e => this.storedNoteFilterSettings.notesCategories.map(h => h.enumNoteCategoryID).includes(e.enumNoteCategoryID));
          if (d) {
            return p;
          }
        });
      } else {
        this.filteredNotes = this.notes.filter(p => {
          const d = p.dataNoteTypes.find(e => this.storedNoteFilterSettings.notesTypes.map(h => h.enumNoteTypeID).includes(e.enumNoteTypeID));
          if (d) {
            return p;
          }
        });
        this.filteredNotes = this.filteredNotes.filter(p => {
          const d = p.dataNoteCategories.find(e => this.storedNoteFilterSettings.notesCategories.map(h => h.enumNoteCategoryID).includes(e.enumNoteCategoryID));
          if (d) {
            return p;
          }
        });
      }
    }
  }

  setupCategoryFilters() {
    this.categoryFilters = [];
    /*this.dataNoteGroups.forEach(noteGroup => {
      noteGroup.display = true;
    });*/
    this.notesCategories.forEach(cat => {
      this.categoryFilters.push({
        displayValue: cat.ItemDisplayValue,
        selected: true,
      });
    });
  }

  getAlertNotes() {
    this.notesService.getAlertNotes(this.patientId).subscribe((alertRes) => {
      this.alertNotes = alertRes;
    });
  }

  getNotes(model: TdoNoteQueryModel) {
    this.getNotesAll(model);
  }

  getNotesAll(model: TdoNoteQueryModel) {
    this.isLoading = true;

    this.notesService.getNotes(model).subscribe((res) => {
      this.notes = res;
      this.sortNotes();
      this.filterNotes();
      this.isLoading = false;
      this.cdr.detectChanges();
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_FILTER_READY, {
        // no need for params
      });
    });
  }

  getNotesForPatientCase() {
    this.isLoading = true;

    this.notesService.getNotesForPatientCase(this.currentCaseId).subscribe((res) => {
      this.notes = res;
      this.sortNotes();
      this.filterNotes();
      this.isLoading = false;
      this.cdr.detectChanges();
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_FILTER_READY, {
        // no need for params
      });
    });
  }

  saveDataNote(model: TdoNoteSaveModel) {
    this.notesService.saveNote(model).subscribe((res) => {
      model.dataNote = res;
      let retModel = this.notes.findIndex(p => p.NoteId === model.dataNote.NoteId);
      if (retModel > -1) {
        this.notes[retModel] = res;
      } else {
        retModel = this.notes.findIndex(p => p.NoteId === undefined);
        if (retModel > -1) {
          this.notes[retModel] = res;
        } else {
          this.notes.unshift(res);
        }
      }
      this.filterNotes();
    });
  }

  onCloseClick(): void {
    this.messagingService.sendComponentMessage('Toggle-Notes-Display', { display: false });
  }

  onSettingsClick() {
    this.isShowSettings = !this.isShowSettings;
  }

  onEmergencyInformationClick() {
    this.storedNoteFilterSettings.isShowAlertNotes = !this.storedNoteFilterSettings.isShowAlertNotes;
    this.saveFilterSettings();
  }

  onFilterClickOutside() {
    if (this.isShowSettings) {
      this.isShowSettings = false;
    }
  }

  onNoteInput(event: string, noteData: NoteDataModel) {
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects: TdoNoteAssociatedObject[] = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    // parentObjectName is the table to associate / group this with.
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    // objectId is the primary key of the parentObjectName table.
    newAssociatedObjectCase.objectId = this.patientCaseId;
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;

    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  onCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[], noteData: NoteDataModel) {
    noteData.dataNoteCategories = items;
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    newAssociatedObjectCase.objectId = this.patientCaseId;
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;
    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  onTypeDropdownSelectionComplete(items: NoteTypeDataModel[], noteData: NoteDataModel) {
    noteData.dataNoteTypes = items;
    const model = new TdoNoteSaveModel();
    model.text = noteData.Note;
    model.patientId = this.patientId;

    const associatedObjects = [];
    const newAssociatedObjectCase = new TdoNoteAssociatedObject();
    newAssociatedObjectCase.objectId = this.patientCaseId;
    newAssociatedObjectCase.parentObjectName = 'dataPatientCase';
    associatedObjects.push(newAssociatedObjectCase);

    model.associatedObjects = associatedObjects;
    model.dataNote = noteData;
    if (!noteData.NoteId) {
      model.text = noteData.Note;
    }
    this.saveDataNote(model);
  }

  getDate(date: Date) {
    const date2 = new Date(date);
    const date1 = ConversionUtilities.convertUTCDateToLocalDate(date2);
    let hours = date1.getHours();
    let demarcation = 'AM';
    if (hours > 12) {
      hours -= 12;
      demarcation = 'PM';
    } else {
      if (hours === 0) {
        hours = 12;
      }
    }

    let minutes = '';
    const minutesNum = date1.getMinutes();
    if (minutesNum < 10) {
      minutes = '0' + minutesNum.toString();
    } else {
      minutes = minutesNum.toString();
    }
    return Constants.monthNamesAbbreviated[date1.getMonth()] + ' ' + date1.getDate() + ', ' + date1.getFullYear() + ' ' + hours + ':' + minutes + ' ' + demarcation;
  }

  openNoteBuilder(dataNote: NoteDataModel) {
    const config = new MatDialogConfig();
    config.data = {
      note: dataNote,
      isLocked: this.isNoteLocked(dataNote)
    };
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoNoteBuilderComponent, config).afterClosed().subscribe((data) => {
      if (data && data.length > 0) {
        dataNote.Note = data;
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          this.uiService.displayMessage('Success', 'Note saved');
        });
      }
    });
  }

  deleteNote(dataNote: NoteDataModel): void {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete this note?`).subscribe((result) => {
      if (result === true) {
        dataNote.xauditDeleted = true;
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          dataNote = resp;
          var noteIndex = this.filteredNotes.findIndex(note => note.NoteId === dataNote.NoteId);
          this.filteredNotes.splice(noteIndex, 1);
        });
      }
    });

  }

  openMacroNotes(dataNote: NoteDataModel, index: number) {
    const cursorPosition = this.noteArea.toArray()[index].nativeElement.selectionStart;
    const config = new MatDialogConfig();
    config.data = dataNote;
    config.panelClass = 'tdo-note-dialog-main';
    this.dialog.open(TdoMacroNotesComponent, config).afterClosed().subscribe((data) => {
      if (data.length > 0) {
        dataNote.Note = dataNote.Note.substring(0, cursorPosition) + '\n' + data + ' ' + dataNote.Note.substring(cursorPosition);
        this.notesService.saveDataNote(dataNote).subscribe((resp) => {
          if (resp) {
            this.uiService.displayMessage('Success', 'Note saved');

          }
          else
            this.uiService.displayMessage('Error', 'Error saving note');
        });
      }
    });
  }

  isNoteLocked(dataNote: NoteDataModel) {
    if (!dataNote) {
      return null;
    }

    // Check if explicitly locked
    if (dataNote.isLocked === true) {
        return true;
    }
    
    // Check if modified more than 24 hours ago
    const nowDate = new Date();
    const modifiedDate = new Date(dataNote.xauditModifiedOn);
    const msDiff = nowDate.getTime() - modifiedDate.getTime();

    // Num milliseconds in 24 hours 86400000
    return msDiff >= 86400000;
  }

  // Filter data
  ////////////////////////////////////////////////////////////////////////////////////////
  onFilterCategoryDropdownSelectionComplete(items: NoteCategoryDataModel[]) {
    if (items.length > 0) {      
      this.storedNoteFilterSettings.notesCategories = items.filter(item => item.enumNoteCategoryID !== this.allCategoryModel.enumNoteCategoryID);;
    } else {
      this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeDropdownSelectionComplete(items: NoteTypeDataModel[]) {
    if (items.length > 0) {
      this.storedNoteFilterSettings.notesTypes = items.filter(item => item.enumNoteTypeID !== this.allTypeModel.enumNoteTypeID);
    } else {
      this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    }

    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterCategorySettingsReset() {
    this.storedNoteFilterSettings.notesCategories = [this.allCategoryModel];
    this.categoryDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onFilterTypeSettingsReset() {
    this.storedNoteFilterSettings.notesTypes = [this.allTypeModel];
    this.typeDropdown.clearCheckboxes();
    this.saveFilterSettings();
    this.filterNotes();
  }

  onCheckboxChange(event: MatCheckboxChange) {
    switch (event.source.ariaLabel) {
      case 'Full View':
        this.storedNoteFilterSettings.isFullView = event.checked;
        if (!this.storedNoteFilterSettings.isFullView) {
          this.storedNoteFilterSettings.isCondensedView = true;
          /*this.storedNoteFilterSettings.isShowCreatedOn = false;
          this.storedNoteFilterSettings.isShowCreatedBy = false;
          this.storedNoteFilterSettings.isShowModifiedOn = false;
          this.storedNoteFilterSettings.isShowModifiedBy = false;*/
        } else {
          this.storedNoteFilterSettings.isCondensedView = false;
          /*this.storedNoteFilterSettings.isShowCreatedOn = true;
          this.storedNoteFilterSettings.isShowCreatedBy = true;
          this.storedNoteFilterSettings.isShowModifiedOn = true;
          this.storedNoteFilterSettings.isShowModifiedBy = true;*/
        }
        break;
      case 'Condensed View':
        this.storedNoteFilterSettings.isCondensedView = event.checked;
        if (!this.storedNoteFilterSettings.isCondensedView) {
          this.storedNoteFilterSettings.isFullView = true;
          /*this.storedNoteFilterSettings.isShowCreatedOn = true;
          this.storedNoteFilterSettings.isShowCreatedBy = true;
          this.storedNoteFilterSettings.isShowModifiedOn = true;
          this.storedNoteFilterSettings.isShowModifiedBy = true;*/
        } else {
          this.storedNoteFilterSettings.isFullView = false;
          /*this.storedNoteFilterSettings.isShowCreatedOn = false;
          this.storedNoteFilterSettings.isShowCreatedBy = false;
          this.storedNoteFilterSettings.isShowModifiedOn = false;
          this.storedNoteFilterSettings.isShowModifiedBy = false;*/
        }
        break;
      case 'Created On':
        this.isAllViewOptionsSelected();
        break;
      case 'Created By':
        this.isAllViewOptionsSelected();
        break;
      case 'Modified On':
        this.isAllViewOptionsSelected();
        break;
      case 'Modified By':
        this.isAllViewOptionsSelected();
        break;
    }

    this.saveFilterSettings();
  }

  isAllViewOptionsSelected() {
    if (this.storedNoteFilterSettings.isShowCreatedBy &&
      this.storedNoteFilterSettings.isShowCreatedOn &&
      this.storedNoteFilterSettings.isShowModifiedBy &&
      this.storedNoteFilterSettings.isShowModifiedOn) {
      // this.storedNoteFilterSettings.isFullView = true;
    } else {
      // this.storedNoteFilterSettings.isFullView = false;

      if (this.storedNoteFilterSettings.isShowCreatedBy === false ||
        this.storedNoteFilterSettings.isShowCreatedOn === false ||
        this.storedNoteFilterSettings.isShowModifiedBy === false ||
        this.storedNoteFilterSettings.isShowModifiedOn === false) {
        // this.storedNoteFilterSettings.isCondensedView = true;
      } else {
        // this.storedNoteFilterSettings.isCondensedView = false;
      }
    }
  }

  getBackgroundColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType.ItemDisplayValue.toLowerCase() === 'alert');
      if (alert) {
        return 'rgba(255,0,0,1)';
      }
    }
    return '';
  }

  getTextColor(note: NoteDataModel) {
    if (note && note.dataNoteTypes) {
      const alert = note.dataNoteTypes.find(p => p.enumNoteType.ItemDisplayValue.toLowerCase() === 'alert');
      if (alert) {
        return 'white';
      } else {
        return 'black';
      }
    } else {
      return '';
    }
  }

  private handleRouteChange(data: NavigationStart) {
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    // model.objectId = this.patientCaseId;
    // this.getNotes(model);
  }

  onExpandNotes() {
    this.uiService.openNotesWindow();
  }

  getTeethString(case1: PatientCaseViewDataModel) {
    return case1.Teeth;
  }

  getSelectedCase() {
    let ret: PatientCaseViewDataModel = null;
    if (this.cases && this.cases.length > 0) {
      ret = this.cases.find(p => p.PatientCaseId === this.currentCaseId);
    }

    return ret;
  }

  onCaseChange(event: MatSelectChange) {
    this.currentCaseId = event.value.PatientCaseId;
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    if (this.currentCaseId !== '*') {
      model.objectId = this.currentCaseId;
    }
    this.getNotes(model);
  }

  onCasesSelectionChange($event: any) {
    const model = new TdoNoteQueryModel();
    model.patientId = this.patientId;
    this.currentCaseId = this.globals.currentPatientCaseId;

    if (!$event) {
      // current case only — include the objectId so the API filters by case
      model.objectId = this.currentCaseId;
    }
    this.getNotes(model);
  }

  copyNote(dataNote: NoteDataModel): void {
    if (dataNote && dataNote.Note) {
      let noteContent = 'Note Created On: ' + this.getDate(dataNote.xauditCreatedOn) + '\n' +
          'By: ' + dataNote.xauditCreatedByUser?.FirstName + ' ' + dataNote.xauditCreatedByUser?.LastName + '\n' +
          'Categories: ' + dataNote.dataNoteCategories.map(c => c.enumNoteCategory.ItemDisplayValue).join(', ') + '\n' +
          'Types: ' + dataNote.dataNoteTypes.map(t => t.enumNoteType.ItemDisplayValue).join(', ') + '\n' +
          'Note: ' + dataNote.Note;
      // Use the modern Clipboard API if available
      if (navigator.clipboard && window.isSecureContext) {
        
        navigator.clipboard.writeText(noteContent).then(() => {
          this.uiService.displayMessage('Success', 'Note copied to clipboard');
        }).catch((err) => {
          console.error('Failed to copy note to clipboard:', err);
          this.fallbackCopyToClipboard(noteContent);
        });
      } else {
        // Fallback for older browsers or non-secure contexts
        this.fallbackCopyToClipboard(noteContent);
      }
    }
  }

  copyAllNotes(): void {
    const noteContent = this.notes.map(dataNote => {
      let note = 'Note Created On: ' + this.getDate(dataNote.xauditCreatedOn) + '\n' +
          'By: ' + dataNote.xauditCreatedByUser?.FirstName + ' ' + dataNote.xauditCreatedByUser?.LastName + '\n' +
          'Categories: ' + dataNote.dataNoteCategories.map(c => c.enumNoteCategory.ItemDisplayValue).join(', ') + '\n' +
          'Types: ' + dataNote.dataNoteTypes.map(t => t.enumNoteType.ItemDisplayValue).join(', ') + '\n' +
          'Note: ' + dataNote.Note;
          return note;
    }).join('\n\n');

    if (navigator.clipboard && window.isSecureContext) {
        
      navigator.clipboard.writeText(noteContent).then(() => {
        this.uiService.displayMessage('Success', 'All notes copied to clipboard');
      }).catch((err) => {
        console.error('Failed to copy notes to clipboard:', err);
        this.fallbackCopyToClipboard(noteContent);
      });
    } else {
      this.fallbackCopyToClipboard(noteContent);
    }
  }

  private fallbackCopyToClipboard(text: string): void {
    try {
      // Create a temporary textarea element
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      // Execute the copy command
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      
      if (successful) {
        this.uiService.displayMessage('Success', 'Note copied to clipboard');
      } else {
        this.uiService.displayMessage('Error', 'Failed to copy note to clipboard');
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.uiService.displayMessage('Error', 'Failed to copy note to clipboard');
    }
  }
}
